import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import documentUploadFormJson from '../../life-config/documentUploadConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import { ApiService } from '../../services/api.service';
import { SharedApiService } from '../../services/shared-api.service';
import { DatePipe } from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';
import trackingInfo from '../../life-config/journey-tracker.json';
import { SharedDataService }  from '../../services/shared-data.service';
@Component({
    selector: 'app-input-file-upload',
    templateUrl: './input-file-tag.component.html',
    styleUrls: ['./input-file-tag.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class InputFileTagComponent implements OnInit {
    documentUploadDataJson: any = documentUploadFormJson.documentUplodJson;
    trackInfo: object = trackingInfo['tracker-info'];
    uuid: string;
    proposalId: string;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    imageURL: string;
    @Output()
    sendMsgEvent = new EventEmitter<string>();
    @Output()
    fileCheck = new EventEmitter<any>();
    @Output()
    formDisable = new EventEmitter<any>();
    @Output()
    fileNum = new EventEmitter<any>();
    @Output()
    fileImgNum = new EventEmitter<any>();
    @Input() uploadedDocData: any;
    @Input() ProoFType: any;
    @Input() indexProp: any;


    toCallService = false;
    PROOF_type: any;

    file: any;
    Documenttype: any = 0;
    DocNumber: any;
    Expiry_date: any;
    reader: FileReader;
    allDocumentData: any;
    @Input() ImageFile: any;
    // images: any = {
    //     imageUrl_1: '',
    //     imageUrl_2: '',
    //     imageUrl_3: '',
    // };
    imageURL1: string;
    imageURL2: string;
    imageURL3: string;
    doc_Id1: number;
    doc_Id2: number;
    doc_Id3: number;
    returnedDocId: number;
    ProofTypeInFo: any;
    showCloseIcon = false;
    doc_id: any;
    fileNotInvalid = true;
    updatedData: any;
    RespData: any;
    UploadedImgNum: number;
    showSpinner = false;

    constructor(
        private apiService: ApiService,
        private datePipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private sharedData: SharedApiService,
        private snackBar: MatSnackBar,
        private sharedDataService:SharedDataService
      ) {


        this.sharedData.invokeEvent.subscribe(value => {
            if (value === 'someVal') {
               // this.spinner.show();
                this.getDocumentData();
            }
        });



        this.sharedDataService.getDocumentDataOnEvent.subscribe(value => {
            if (value) {
               // this.spinner.show();
                this.getDocumentData();
            }
        });
    }

    

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            this.uuid = params['uuid'];
            this.proposalId = params['proposalId'];
        });

        this.getDocumentData();
        if (this.imageURL !== '' || this.imageURL1 !== '' || this.imageURL2 !== '' || this.imageURL3 !== '') {
           // this.spinner.hide();
        } else {
           // this.spinner.show();
        }

    }

// Image Preview
showPreview(event, imgNum) {
    const postDocUrl = this.apiUrl['apiDocumentUpload'];
    const proposalId = this.proposalId;
    const uuid = this.uuid;
    const queryParamsURL1 = this.apiUrl['fetch_docs'];

    // this.apiService.getDocumentUploadedData(postDocUrl, proposalId, uuid, queryParamsURL1)
    // .subscribe((res: Response) => {
    let replyData: any;
    let i = 0;
    if (localStorage.getItem('uploadData') !== "undefined"){
        replyData = JSON.parse(localStorage.getItem('uploadData'));
        // = res['docs'];
        if (replyData !== null)  {
       // tslint:disable-next-line: forin
    for (const item of replyData) {
        // tslint:disable-next-line: no-debugger
        if (item['proof_type'] === this.ProoFType && this.ProoFType !== 0 && this.ProoFType !== 6) {
            i = i + 1;
        }
      }
    }
}

    if (imgNum > i) {
        if (imgNum - i > 1) {
            this.fileImgNum.emit(imgNum);
            return;
        }
    }
    if (i < 1) {
         if (imgNum > 1) {
          this.fileImgNum.emit(imgNum);
          return;
         }
       }
    const myArray = [11, 28, 20, 15, 10, 13, 32, 12, 34];
    const addressArray = [24, 25, 26, 30];
    this.fileImgNum.emit(0);
    if (this.uploadedDocData == undefined && !(this.ProoFType == 0 || this.ProoFType == 6)) {

        this.sendMsgEvent.emit('checkVal');

    } else {
        this.PROOF_type = this.ProoFType;
        if (this.ProoFType == 0 || this.ProoFType == 6) {
            if (this.ProoFType == 0) {
                this.Documenttype = 9;
            }
            if (this.ProoFType == 6) {
                this.Documenttype = 6;
            }
            
            this.DocNumber = null;
            this.Expiry_date = null;
            this.file = (event.target as HTMLInputElement).files[0];
            if (this.file !== undefined) {
                this.fileCheck.emit(true);
                // this.spinner.show();
            }
            // tslint:disable-next-line: max-line-length
            const fileSize = Math.round(this.file.size / 1024);
            /**
             * handling file type to avoid unncecssary image/file upload
             */
            
            // tslint:disable-next-line: max-line-length
            if ( ((!(this.file['type']['match']('image/jpeg') || this.file['type']['match']('pdf.*'))) && this.ProoFType == 6) ||  ((!this.file['type']['match']('image/jpeg')) && this.ProoFType == 0) || (this.file.name.includes('.pjp') || this.file.name.includes('.pjpeg') || this.file.name.includes('.jfif')) ) {

             // return  this.snackBar.open('invalid image');
              this.snackBar.open('.jpg, .JPEG are the acceptable Image formats. Please re-upload the image as per allowed formats', '' , {
                duration: 2000
              });
              this.fileNotInvalid = false;
              this.fileCheck.emit(false);
   
              return;
             }

           

            /**
             * handling file size if it exceeds more than 5 MB
             */
            if (fileSize > 5120 ) {
               // return this.snackBar.open('Cannot upload image  more than 5 MB');
                this.snackBar.open('Cannot upload image  more than 5 MB', '' , {
                    duration: 5000
                  });
                this.fileNotInvalid = false;
                this.fileCheck.emit(false);
                return;
            }
            // File Preview
            this.reader = new FileReader();
            this.reader.onload = () => {
                this.imageURL = this.reader.result as string;
                this.imageURL1 = this.reader.result as string;
                this.imageURL2 = this.reader.result as string;
                this.imageURL3 = this.reader.result as string;
            };
            // if (this.fileNotInvalid && this.file !== undefined) {
            //     this.fileCheck.emit(true);
            // }
            this.reader.readAsDataURL(this.file);
            this.showCloseIcon = true;
            this.showSpinner = true;
            this.UploadService(this.file, this.PROOF_type, this.Documenttype, this.DocNumber, this.Expiry_date);
        } else {
            this.Documenttype = this.uploadedDocData.documentInfo;
            if ((this.ProoFType == 4) || (addressArray.findIndex(x => x == this.Documenttype) >= 0)) {
                this.DocNumber = null;
                this.Expiry_date = null;
                this.file = (event.target as HTMLInputElement).files[0];
                if (this.file !== undefined) {
                    this.fileCheck.emit(true);
                    this.showCloseIcon = true;
                }
                // tslint:disable-next-line: max-line-length
                const fileSize = Math.round(this.file.size / 1024);
                /**
                 * handling file type to avoid unncecssary image/file upload
                 */
                if ( (!(this.file['type']['match']('image/jpeg') || this.file['type']['match']('pdf.*'))) || (this.file.name.includes('.pjp') || this.file.name.includes('.pjpeg') || this.file.name.includes('.jfif')) )  {

                 // return  this.snackBar.open('invalid image');
                  this.snackBar.open('.pdf, .jpg, .JPEG are the acceptable Image formats. Please re-upload the image as per allowed formats', '' , {
                    duration: 2000
                  });
                  this.fileNotInvalid = false;
                  this.fileCheck.emit(false);
                  return;
                }

                /**
                 * handling file size if it exceeds more than 5 MB
                 */
                if (fileSize > 5120 ) {
                   // return this.snackBar.open('Cannot upload image  more than 5 MB');
                    this.snackBar.open('Cannot upload image  more than 5 MB', '' , {
                        duration: 5000
                      });
                    this.fileNotInvalid = false;
                    this.fileCheck.emit(false);
                    return;
                }
                this.reader = new FileReader();
                this.reader.onload = () => {
                    this.imageURL = this.reader.result as string;
                    this.imageURL1 = this.reader.result as string;
                    this.imageURL2 = this.reader.result as string;
                    this.imageURL3 = this.reader.result as string;
                };
                this.reader.readAsDataURL(this.file);
                this.showCloseIcon = true;
                this.showSpinner = true;
                this.UploadService(this.file, this.PROOF_type, this.Documenttype, this.DocNumber, this.Expiry_date);
            }
        }

        if (!(this.ProoFType == 0 || this.ProoFType == 6)) {
           let k = 0;
           for (const key in this.uploadedDocData) {
                if (this.uploadedDocData.hasOwnProperty(key)) {
                    if (this.uploadedDocData[key])  {
                        this.file = (event.target as HTMLInputElement).files[0];
                        if (k == 0) {
                       if ((myArray.findIndex(x => x == this.Documenttype) >= 0) && (this.Documenttype == 20 || this.Documenttype == 15 || this.Documenttype == 13  || this.Documenttype == 32 || this.Documenttype == 34) && (this.PROOF_type != 6 || this.PROOF_type != 0 || this.PROOF_type != 4)) {
                        this.DocNumber = this.uploadedDocData.docNumInfo;
                        this.Expiry_date = this.uploadedDocData.expiryDateInfo;
                        if (this.Expiry_date != null) {
                            this.Expiry_date = this.datePipe.transform(new Date(this.uploadedDocData.expiryDateInfo), 'yyyy-MM-dd');
                        }
                        if (this.Expiry_date != null &&  this.DocNumber != null) {
                                k = k + 1;
                                 // tslint:disable-next-line: max-line-length
                                const fileSize = Math.round(this.file.size / 1024);
                                /**
                                 * handling file type to avoid unncecssary image/file upload
                                 */
                                if ( (!(this.file['type']['match']('image/jpeg') || this.file['type']['match']('pdf.*'))) || (this.file.name.includes('.pjp') || this.file.name.includes('.pjpeg') || this.file.name.includes('.jfif')) )  {

                                // return  this.snackBar.open('invalid image');
                                this.snackBar.open('.pdf, .jpg, .JPEG are the acceptable Image formats. Please re-upload the image as per allowed formats', '' , {
                                    duration: 2000
                                });
                                this.fileNotInvalid = false;
                                this.fileCheck.emit(false);
                                return;
                                }

                                /**
                                 * handling file size if it exceeds more than 5 MB
                                 */
                                if (fileSize > 5120 ) {
                                // return this.snackBar.open('Cannot upload image  more than 5 MB');
                                    this.snackBar.open('Cannot upload image  more than 5 MB', '' , {
                                        duration: 5000
                                    });
                                    this.fileNotInvalid = false;
                                    this.fileCheck.emit(false);
                                    return;
                                }
                                this.reader = new FileReader(); /* aaaa */
                                this.reader.onload = () => {
                                    this.imageURL = this.reader.result as string;
                                    this.imageURL1 = this.reader.result as string;
                                    this.imageURL2 = this.reader.result as string;
                                    this.imageURL3 = this.reader.result as string;
                                };
                                this.reader.readAsDataURL(this.file);
                                this.showCloseIcon = true;
                                this.showSpinner = true;
                                this.UploadService(this.file, this.PROOF_type, this.Documenttype, this.DocNumber, this.Expiry_date);
                            } else {
                                this.sendMsgEvent.emit('checkVal');
                            }
                        } else if ((myArray.findIndex(x => x == this.Documenttype) >= 0) && (this.PROOF_type != 4 || this.PROOF_type != 6 || this.PROOF_type != 0)) {
                            this.DocNumber = this.uploadedDocData.docNumInfo;
                            if (this.DocNumber) {
                                k = k + 1;
                                 // tslint:disable-next-line: max-line-length
                                const fileSize = Math.round(this.file.size / 1024);
                                /**
                                 * handling file type to avoid unncecssary image/file upload
                                 */
                                if ( (!(this.file['type']['match']('image/jpeg') || this.file['type']['match']('pdf.*'))) || (this.file.name.includes('.pjp') || this.file.name.includes('.pjpeg') || this.file.name.includes('.jfif'))) {

                                // return  this.snackBar.open('invalid image');
                                this.snackBar.open('.pdf, .jpg, .JPEG are the acceptable Image formats. Please re-upload the image as per allowed formats', '' , {
                                    duration: 2000
                                });
                                this.fileNotInvalid = false;
                                this.fileCheck.emit(false);
                                return;
                                }

                                /**
                                 * handling file size if it exceeds more than 5 MB
                                 */
                                if (fileSize > 5120 ) {
                                // return this.snackBar.open('Cannot upload image  more than 5 MB');
                                    this.snackBar.open('Cannot upload image  more than 5 MB', '' , {
                                        duration: 5000
                                    });
                                    this.fileNotInvalid = false;
                                    this.fileCheck.emit(false);
                                    return;
                                }
                                this.reader = new FileReader();
                                this.reader.onload = () => {
                                    this.imageURL = this.reader.result as string;
                                    this.imageURL1 = this.reader.result as string;
                                    this.imageURL2 = this.reader.result as string;
                                    this.imageURL3 = this.reader.result as string;
                                };
                                this.reader.readAsDataURL(this.file);
                                this.showCloseIcon = true;
                                this.showSpinner = true;
                                this.UploadService(this.file, this.PROOF_type, this.Documenttype, this.DocNumber, this.Expiry_date);
                            } else {
                                this.sendMsgEvent.emit('checkVal');
                            }
                        }
                      }
                    } else {
                        this.sendMsgEvent.emit('checkVal');
                    }
                }
            }
        }
    }
  // });
}







    UploadService(document, PROOF_type, Documenttype, DocNumber, Expiry_date) {
        const postDocUrl = this.apiUrl['apiDocumentUpload'];
        const proposalId = this.proposalId;
        const uuid = this.uuid;
        const queryParamsURL = this.apiUrl['upload_doc'];
        const formData: any = new FormData();
        formData.append('document', document);
        formData.append('proof_type', PROOF_type);
        formData.append('doc_type', Documenttype);
        if (DocNumber) {
            formData.append('doc_number', DocNumber);
        }
        if (Expiry_date) {
            formData.append('expiry_date', Expiry_date);
        }
        const mergedObjectInfoData ={
            journey_track: this.trackInfo['UPLOAD_DOCUMENTS']
        }
        this.apiService.updateProposal(
            this.apiUrl['apiV2LifeProposal'],
            this.proposalId, this.uuid,
            this.apiUrl['update_proposal'],
            mergedObjectInfoData).subscribe(res => {
                
        },
            err => {
                console.log('sonething went at our end', err);
            });
        this.apiService.postDocumentData(postDocUrl, proposalId, uuid, queryParamsURL, formData)
            .subscribe(res => {
                localStorage.setItem('uploadData', JSON.stringify(res['docs']));
                // console.log("Inside upload Service", localStorage.getItem("uploadData"));
             },
            err => console.log(err),
            () => this.getDocumentData());
    }

    deleteUploadService(returnedDocId) {
        this.showSpinner = true;
        this.fileNum.emit(0);
        const postDocUrl1 = this.apiUrl['apiDocumentUpload'];
        const proposalId1 = this.proposalId;
        const uuid1 = this.uuid;
        const queryParamsURL1 = this.apiUrl['fetch_docs'];

        this.apiService.getDocumentUploadedData(postDocUrl1, proposalId1, uuid1, queryParamsURL1)
        .subscribe((res: Response) => {
        let proofType = 0;
        let i = -1;
        // tslint:disable-next-line: forin
        const replyData: any = res['docs'];
        for (const item of replyData) {
            // tslint:disable-next-line: no-debugger
           
            if (item['id'] === returnedDocId) {
                proofType  = item['proof_type'];
            }
        }
        // tslint:disable-next-line: forin
        for (const item of replyData) {
            // tslint:disable-next-line: no-debugger
            
            if (item['proof_type'] === proofType && proofType !== 0 && proofType !== 6) {
                i = i + 1;
                if (item['id'] > returnedDocId) {
                    this.fileNum.emit(i);
                   // this.showSpinner = false;
                    return;
                }
            }
        }
        const postDocUrl = this.apiUrl['apiDocumentUpload'];
        const proposalId = this.proposalId;
        const uuid = this.uuid;
        const queryParamsURL = this.apiUrl['delete_doc'];
        this.PROOF_type = this.ProoFType;
        if (this.PROOF_type == 0 || this.PROOF_type == 6) {
           // this.Documenttype = 0;
        } else {
            for (const key in this.uploadedDocData) {
                if (this.uploadedDocData.hasOwnProperty(key)) {
                    if (this.uploadedDocData[key]) {
                        this.Documenttype = this.uploadedDocData.documentInfo;
                    }
                }
            }
        }
       
        if (returnedDocId !== undefined) {
        this.showSpinner = true;
        this.apiService.deleteDocumentData(postDocUrl, proposalId, uuid, queryParamsURL, this.Documenttype , this.PROOF_type, returnedDocId)
            .subscribe((res: any) => {
                this.showSpinner = false;
                localStorage.setItem("uploadData", JSON.stringify(res['docs']));

                if (res.response == true) {
                        this.imageURL = '';
                        this.imageURL1 = '';
                        this.imageURL2 = '';
                        this.imageURL3 = '';
                        this.showCloseIcon = false;
                        this.Documenttype = 0;
                        this.DocNumber = '';
                        this.Expiry_date = '';

                }
            },
            err => this.showSpinner = false,
            () => this.getDocumentData()
            );
        } else {
           // this.deleteUploadService(returnedDocId);
           // return;
        }
    });
    }

    getDocumentData() {
        this.showSpinner = true;
        this.imageURL = '';
        this.imageURL1 = '';
        this.imageURL2 = '';
        this.imageURL3 = '';
        this.RespData = '';
        const postDocUrl = this.apiUrl['apiDocumentUpload'];
        const proposalId = this.proposalId;
        const uuid = this.uuid;
        const queryParamsURL = this.apiUrl['fetch_docs'];

        this.apiService.getDocumentUploadedData(postDocUrl, proposalId, uuid, queryParamsURL)
        .subscribe((res: Response) => {
            //console.log('res', res);
            this.RespData = res['docs'];
            this.allDocumentData = res['docs'];
            this.sharedData.getDocumentInfo(this.allDocumentData);

            if (this.allDocumentData) {
                let i = 1;



                for (const element of this.allDocumentData) {
                   this.Documenttype = element['doc_type'];
                   this.doc_id = element['id'];
                 //  console.log('this.allDocumentData', this.allDocumentData);



                   if (element && this.ProoFType == element['proof_type']) {
                      // this.imageURL = element['doc_url'];
                      //  this.ProofTypeInFo = element['proof_type']

                        if (i == 1) {
                            this.imageURL1 = element['doc_url'];
                            this.doc_Id1 = element['id'];
                        }
                        if (i == 2) {
                            this.imageURL2 = element['doc_url'];
                            this.doc_Id2 = element['id'];
                        }
                        if (i == 3) {
                            this.imageURL3 = element['doc_url'];
                            this.doc_Id3 = element['id'];
                        }

                      //  this.images['imageUrl_'+i] = element['doc_url'];

                        i = i + 1;


                    }

                }
                this.showSpinner = false;


            } else {
                this.showSpinner = false;
            }
        },
        err => console.log(err),
        () => this.getImage());
    }

    getImage() {
        if (this.indexProp == 1) {
            this.imageURL = this.imageURL1;
            this.returnedDocId = this.doc_Id1;
            this.UploadedImgNum = 1;
            this.formDisable.emit({ propIndex: 1, img1: this.imageURL1, img2 : this.imageURL2, img3 : this.imageURL3 });
            this.fileCheck.emit({ propIndex: 1, img1: this.imageURL1, img2 : this.imageURL2, img3 : this.imageURL3 });
            // if (this.imageURL == '') {
            //     this.formDisable.emit({ propIndex: 1, img1: this.imageURL1, img2 : this.imageURL1, img3 : this.imageURL1 });
            // } else {
            //     this.formDisable.emit(true);
            // }
        }
        if (this.indexProp == 2) {
            this.imageURL = this.imageURL2;
            this.returnedDocId = this.doc_Id2;
            this.UploadedImgNum = 2;
            this.formDisable.emit({ propIndex: 2, img1: this.imageURL1, img2 : this.imageURL2, img3 : this.imageURL3 });
            this.fileCheck.emit({ propIndex: 2, img1: this.imageURL1, img2 : this.imageURL2, img3 : this.imageURL3 });
            // if (this.imageURL == '') {
            //     this.formDisable.emit(false);
            // } else {
            //     this.formDisable.emit(true);
            // }
        }
        if (this.indexProp == 3) {
            this.imageURL = this.imageURL3;
            this.returnedDocId = this.doc_Id3;
            this.UploadedImgNum = 3;
            this.formDisable.emit({ propIndex: 3, img1: this.imageURL1, img2 : this.imageURL2, img3 : this.imageURL3 });
            this.fileCheck.emit({ propIndex: 3, img1: this.imageURL1, img2 : this.imageURL2, img3 : this.imageURL3 });
            // if (this.imageURL == '') {
            //     this.formDisable.emit(false);
            // } else {
            //     this.formDisable.emit(true);
            // }
        }
        if (this.imageURL !== '') {
            this.showCloseIcon = true;
          //  this.fileCheck.emit(true);
           // this.formDisable.emit(true);
            // this.spinner.hide();
        } else {
            this.showCloseIcon = false;
          //  this.fileCheck.emit(false);
           // this.formDisable.emit(false);
            // this.spinner.show();
        }


       // this.imageURL = this.images['imageUrl_'+this.indexProp]
    }

    getCSSClasses() {
        let cssClasses;
        if (this.imageURL) {
           cssClasses = {
             indexImg: true
           };
        } else {
           cssClasses = {
             indexImg: false
           };
        }
        return cssClasses;
      }

}
